import React from "react";
import styled from "styled-components";
import { CTA } from "../../../components/CTA";
const _BladeHeader = ({ supertitle, title, subtitle, description, links, ...props }) => {
    const hasLinks = links && links.length > 0;
    return (React.createElement("div", { className: "header", ...props },
        React.createElement("div", { className: "titleContainer", "data-testid": "title" }, title && React.createElement("h3", null, title)),
        hasLinks ? (React.createElement("div", { className: "linkContainer", "data-testid": "links" }, links.map((link, index) => (React.createElement(CTA, { variant: "tertiary", className: `cta-${index}`, ...link, key: index, "data-testid": `cta-${index}` }))))) : null));
};
_BladeHeader.defaultProps = {
    "data-testid": "bladeheader",
};
export const BladeHeader = styled(_BladeHeader) ``;
//# sourceMappingURL=BladeHeader.js.map